<template>
  <div>
    <v-row class="pa-10">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
            verified_user
          </v-icon>
          {{$t('display/certificate:certificates')}}
        </h2>
        <v-card class="general-datatable ma-1" elevation="0">
          <v-card-title class="pa-5 pb-4">
            <v-btn
              outlined
              color="primary"
              @click="updateGuacamole"
            >
              <v-icon>autorenew</v-icon>
              {{$t('display/certificate:guacamole-ip-update')}}
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="certificates"
              disable-filtering
              disable-sort
              hide-default-footer
              class="elevation-1 pb-10"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  @click="sendAction(item)"
                  icon
                  class="ma-2"
                  :color="item.state === 'PENDING'? 'primary' : 'red'" >
                  <v-icon>{{ item.state === 'ACCEPTED' ? 'block' : 'check' }}</v-icon>
                </v-btn>
                <v-btn
                  @click="sendAction(item, true)"
                  icon
                  class="ma-2"
                  v-if="item.state === 'PENDING'"
                  color="red" >
                  <v-icon>block</v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.state`]="{ item }" >
                <v-icon>{{ item.state === 'ACCEPTED' ? 'verified_user' : 'scheduled'}}</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <TwoButtonDialog
      ref="deleteButton"
      :dialog-title="$t('dialog:delete-btn-title', {name : $t('display/certificate:certificate')})"
      :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('display/certificate:certificate')})"
      :button1-text="$t('buttons:cancel')"
      :button2-text="$t('buttons:delete')"
      :hideButton="true"
      @clickedButton1="$refs.deleteButton.showDialog = false"
      @clickedButton2="blockAction"
    />

  </div>
</template>

<script>
import Utils from '@/modules/core/services/utils';
import CertificateService from '@/modules/display/services/certificate-service';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';

export default {
  components: { TwoButtonDialog },
  name: 'CertificateOverview',
  data() {
    return {
      certificates: [],
      currentCertificate: {}
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('display/certificate:client-id'), value: 'id' },
        { text: this.$t('display/certificate:mac'), value: 'hardware_id' },
        { text: this.$t('display/certificate:valid'), value: 'created_at' },
        { text: this.$t('display/certificate:valid'), value: 'updated_at' },
        { text: this.$t('common:active'), value: 'state' },
        { text: "", value: 'actions', sortable: false },
      ]
    }
  },
  methods: {
    getAllCertificates() {
      CertificateService.readFromAPI(
        (response) => {
          this.certificates = response.data;
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/certificate:certificates')}));
        }
      )
    },
    updateGuacamole() {
      CertificateService.updateGuacamole(
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:finish-success', {name: this.$t('display/certificate:guacamole-request')}));
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:finish-failure', {name: this.$t('display/certificate:guacamole-request')}));
        }
      )
    },
    sendAction(item, block) {
      if (item.state === 'PENDING' && !block) {
        this.activateAction(item)
      } else {
        this.$refs.deleteButton.showDialog = true;
        this.currentCertificate = item;
      }
    },
    blockAction() {
      this.$refs.deleteButton.showDialog = false
      CertificateService.blockCertificate(
        this.currentCertificate,
        () => {
          this.getAllCertificates();
          Utils.showSuccessSnackbar(this.$t('snackbar:finish-success', {name: this.$t('display/certificate:guacamole-request')}));
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:finish-failure', {name: this.$t('display/certificate:guacamole-request')}));
        }
      )
    },
    activateAction(item) {
      CertificateService.activateCertificate(
        item,
        () => {
          this.getAllCertificates();
          Utils.showSuccessSnackbar(this.$t('snackbar:finish-success', {name: this.$t('display/certificate:guacamole-request')}));
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:finish-failure', {name: this.$t('display/certificate:guacamole-request')}));

        }
      )
    }
  },
  created() {
    this.getAllCertificates();
  }
}
</script>

<style src="@/modules/core/components/DataTable/DataTable.scss" lang="scss"/>